export default "__VITE_ASSET__9ed57155__"